import { render } from "./pro-setting.html?vue&type=template&id=b2f09ce8&scoped=true&ts=true"
import script from "./pro-setting.ts?vue&type=script&lang=ts"
export * from "./pro-setting.ts?vue&type=script&lang=ts"

import "./pro-setting.scss?vue&type=style&index=0&id=b2f09ce8&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2f09ce8"]])

export default __exports__